/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState, useMemo } from "react";
import { LargeFeedFilter } from "cms/shared/feeds/large";
import { FeedbackForm } from "components/feedback-form";
import { SubscribeButton } from "mydnv/components/subscribe-button";
import { FollowedInfoCard } from "mydnv/components/followed-infocard/followed-infocard";
import { WhenSignedIn } from "mydnv/components/sign-in/sign_in_out_util";
import { BookmarkButton } from "mydnv/components/bookmark-button";
import { ShareButton } from "cms/shared/share-button";
import { ModelFeatureGuard } from "cms/model-feature-guard.jsx";
import { FeatureFlagGuard } from "cms/features/feature-flag-guard.jsx";
import { Config } from "config";

const News = () => {

    const type = "model.news";
    const [subTopic, setSubtopic] = useState("");

    // determines what message / style to show in 'info card' after follow / subscribe / bookmark buttotn clicked
    const [actionType, setActionType] = useState(null);

    const wpGuid = Config.MyDNV.webpageGuidsList.news;
    const wpObj = useMemo(() => {
        return {
            guid: wpGuid,
            title: "News",
            published_date: null,
            updated_date: null,
        };
    }, [wpGuid]);

    return (
        <main>
            <WhenSignedIn>
                {actionType !== null && (
                    <FollowedInfoCard type={actionType} handleDismiss={setActionType} subTopic={subTopic} />
                )}
            </WhenSignedIn>

            <h1 style={{ marginTop: "16px" }}>News</h1>

            {/* Share bar */}
            <div className='nav-container'>
                <div>
                    {/*<FeatureFlagGuard feature="feature_last_updated">*/}
                    {/*    <ModelFeatureGuard modelFeature="page_last_updated">*/}
                    {/*        <LastModified className='modified-time-nav' model={model} />*/}
                    {/*    </ModelFeatureGuard>*/}
                    {/*</FeatureFlagGuard>*/}
                </div>
                <div className='buttons-container no-date news'>
                    <SubscribeButton
                        subscriptionTopic='News'
                        className='subscribe-btn-nav'
                        setActionType={setActionType}
                        webpageGuid={wpGuid}
                        setSubtopic={setSubtopic}
                    ></SubscribeButton>

                    <BookmarkButton setActionType={setActionType} wpObj={wpObj}></BookmarkButton>

                    <ShareButton className='share-btn-nav' />
                </div>
            </div>
            <div className='last-updated-rule'></div>

            {/* <Layout_TwoColumnSideNav /> */}

            <LargeFeedFilter type={type} enableBar={true} />

            <FeatureFlagGuard feature="feature_was_helpful">
                <ModelFeatureGuard modelFeature="feedback_form">
                    <FeedbackForm />
                </ModelFeatureGuard>
            </FeatureFlagGuard>
        </main>
    );
};

export { News };
